import {Component, effect, signal} from '@angular/core';
import {AppConstants} from '../../app.constants';
import {RouterLink} from '@angular/router';

@Component({
    selector: 'app-nav-bar',
    standalone: true,
    imports: [
        RouterLink
    ],
    templateUrl: './nav-bar.component.html',
    styleUrl: './nav-bar.component.scss'
})
export class NavBarComponent {
    protected isNavMinimized = signal(AppConstants.getNavBarMinimized());

    constructor() {
        effect(() => AppConstants.setNavBarMinimized(this.isNavMinimized()));
    }

    toggleNavMinimized() {
        this.isNavMinimized.set(!this.isNavMinimized());
    }
}
